import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { REQUEST_STATUS } from '../../../constants/request'
import { ROLE_TRANSLATION_ALIASES } from '../../../constants/user'
import { EntityStatus } from '../../Entity'
import { SearchItem } from '../../Search'

import { REQUEST_SEARCH_ITEM_ICON } from './RequestSearchItem.constants'

import * as styles from './RequestSearchItem.module.css'

function RequestSearchItem({ className = styles.RequestSearchItem, value }) {
  const { address_obj, archived, flat_obj, owner, request_no, status, title } =
    value.item ?? EMPTY_OBJECT

  const { value: address } = address_obj ?? EMPTY_OBJECT
  const { number: flat } = flat_obj ?? EMPTY_OBJECT

  const { t } = useTranslation()

  const ownerText = `${owner.name} ${owner.second_name} | ${t(ROLE_TRANSLATION_ALIASES[owner.role])}`

  const additional = [
    status ? <EntityStatus id={status} statuses={REQUEST_STATUS} /> : null,
    flat,
    address,
    ownerText,
  ]

  const titleText = `${t('Request.RequestNumberKey')} ${request_no} ${title}`

  return (
    <SearchItem
      additional={additional}
      archived={archived}
      className={className}
      icon={REQUEST_SEARCH_ITEM_ICON}
      title={titleText}
    />
  )
}

export default RequestSearchItem
